import { useEffect } from "react";
import { Link, useRouteError } from "react-router";
import { useAnalytics } from "@repo/analytics";
import { useTranslation } from "@repo/i18n";
import { css } from "@repo/styled-system/css";

/**
 * Per-route error fallback (ADR-0015): a loader/render error in one route shows this instead
 * of taking down the whole SPA. Reports through the AnalyticsClient port.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();
  const analytics = useAnalytics();
  const { t } = useTranslation();

  useEffect(() => {
    analytics.captureException(error, { boundary: "route" });
  }, [analytics, error]);

  return (
    <main
      role="alert"
      className={css({ p: "8", display: "flex", flexDirection: "column", gap: "4", maxW: "md" })}
    >
      <h1 className={css({ fontSize: "2xl", fontWeight: "bold" })}>{t("error.title")}</h1>
      <p className={css({ color: "fg.muted" })}>{t("error.subtitle")}</p>
      <Link to="/" className={css({ color: "accent.default", textDecoration: "underline" })}>
        {t("error.home")}
      </Link>
    </main>
  );
}
